export enum WidgetTypeEnum {
    ACD_WALLBOARD_BOTTOM = 'ACD_WALLBOARD_BOTTOM',
    ACD_WALLBOARD_RIGHT = 'ACD_WALLBOARD_RIGHT',
    BAR_CHART = 'BAR_CHART',
    CLOCK = 'CLOCK',
    COLUMN_CHART = 'COLUMN_CHART',
    DATA_TABLE = 'DATA_TABLE',
    DOUGHNUT_CHART = 'DOUGHNUT_CHART',
    FREE_TEXT = 'FREE_TEXT',
    IFRAME = 'IFRAME',
    LINE_CHART = 'LINE_CHART',
    NOT_SELECTED = 'NOT_SELECTED',
    OBM_CAMPAIGN_OVERVIEW = 'OBM_CAMPAIGN_OVERVIEW',
    OBM_USER_RANKING = 'OBM_USER_RANKING',
    PICTURE = 'PICTURE',
    RADAR_CHART = 'RADAR_CHART',
    RSS_FEED = 'RSS_FEED',
    SINGLE_VALUE = 'SINGLE_VALUE',
    SUPERSET_DASHBOARD = 'SUPERSET_DASHBOARD',
    VIDEO = 'VIDEO',
    WEATHER = 'WEATHER',
}
